import { createVuetify } from "vuetify";
import { VTimePicker } from "vuetify/labs/VTimePicker";
import { VNumberInput } from "vuetify/labs/VNumberInput";
import { aliases, md } from "vuetify/iconsets/md";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/styles";

export default defineNuxtPlugin(({ vueApp }) => {
  const config = useAppConfig();
  const vuetify = createVuetify({
    ssr: false,
    defaults: {
      VBtn: {
        rounded: "xl",
      },
    },
    icons: {
      defaultSet: "md",
      aliases,
      sets: {
        md,
      },
    },
    theme: {
      defaultTheme: "light",
      themes: config.theme.themes,
    },
    components: { VTimePicker, VNumberInput },
    // date: {
    //   adapter: DayJsAdapter,
    // },
  });

  vueApp.use(vuetify);
});
